import { isStoryblokEditMode } from './isStoryblokEditMode';

export type Version = 'draft' | 'published';

export default function getStoryBlokVersion(env: string, route?: any): Version {
  if (env === 'prod' && !isStoryblokEditMode(route)) return 'published';
  return 'draft';
}
